import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./domoFunnel.scss";

const maxHeight = 100;
let maxCylinder;
let totalCount;

let colors = [
  "blue",
  "green",
  "orange",
  "red",
  "darkblue",
  "marsala",
  "darkgreen",
  "magenta",
  "hotpink",
  "caribbeangreen",
  "strongorange",
  "darkcyan"
];

const DomoFunnel = ({ dataArray = [], chartWidth, label }) => {
  useEffect(() => {
    createChart();
  }, []);

  const totalOffers = (data) => {
    let offersTotal = 0;
    data[1].map((item) => {
      offersTotal = offersTotal + item[0];
    });
    return offersTotal;
  };

  const convertToAny = (data, index) => {
    let offersTotal = 0;
    let total = 0;
    data[index].map((item) => {
      total = total + item[0];
    });
    data[1].map((item) => {
      offersTotal = offersTotal + item[0];
    });
    return `${total} of ${offersTotal} (${
      isNaN(Math.floor((total / offersTotal) * 100)) ? 0 : Math.floor((total / offersTotal) * 100)
    }%)`;
  };

  const createChart = () => {
    totalCount = 0;
    $("#mroichart").empty();
    countTotal();

    for (let r = 0; r < dataArray.length; r++) {
      let parDiv = document.createElement("div");
      $(parDiv).addClass("chartsection");

      for (let c = 0; c < dataArray[r].length; c++) {
        let childDiv = document.createElement("div");
        let childDiv2 = document.createElement("div");
        let ul = document.createElement("ul");
        let span1;

        let h5 =
          '<h5 data-toggle="tooltip" data-placement="top" ' +
          "title=" +
          '"' +
          dataArray[r][c] +
          '"' +
          ">" +
          dataArray[r][c] +
          "</h5>";

        if (r === 0) {
          $(parDiv).append(childDiv);
          $(childDiv2).addClass("elltooltip");
          $(childDiv2).attr("data-url", dataArray[r + 1][c][2]);
          $(childDiv2).append(h5);
        } else if (r !== 0 && r !== dataArray.length - 1) {
          $(parDiv).addClass("sec s" + r);
          $(childDiv2).addClass("rectslice");
          $(childDiv2).attr("data-url", dataArray[r][c][2]);

          let elWidth = (dataArray[r][c][0] / totalCount) * chartWidth;
          let minWidth = dataArray[r][c][0].toString().length * 8;
          let sliceWidth = minWidth > elWidth ? minWidth : elWidth;
          let width = elWidth > 22 ? sliceWidth : elWidth;

          $(childDiv2).css({ width });

          span1 =
            `<span class=${
              width > 22 ? '""' : "hide-number"
            } data-toggle="tooltip" data-html="true" data-placement="top" ` +
            "title=" +
            '"' +
            dataArray[r][c][1] +
            '"' +
            ">" +
            dataArray[r][c][0] +
            "</span>";

          $(childDiv2).append(span1);
        } else {
          $(childDiv2).addClass("cillindreslice");
          $(childDiv2).attr("data-url", dataArray[4][c][4]);
          let elheight = Math.round((dataArray[r][c][0] / maxCylinder) * maxHeight);
          $(childDiv2).css({ height: elheight });
          childDiv2.append(ul);
          $(ul).css({ height: elheight });

          let spanServices =
            '<span data-toggle="tooltip" data-placement="top" ' +
            "title=" +
            '"Service Revenue: ' +
            dataArray[4][c][2] +
            '">' +
            "</span>";

          let spanProducts =
            '<span data-toggle="tooltip" data-placement="top" ' +
            "title=" +
            '"Product Revenue: ' +
            dataArray[4][c][3] +
            '">' +
            "</span>";

          let color1 = colors[c];

          $(ul).append(
            '<li class="service-bar ' +
              color1 +
              '"' +
              ' style="opacity:0.9;' +
              '"' +
              ">" +
              spanServices +
              "</li>" +
              '<li class="product-bar ' +
              color1 +
              '"' +
              ' style="opacity:0.5;' +
              '"' +
              ">" +
              spanProducts +
              "</li>"
          );
        }
        $(childDiv2).addClass(colors[c]);
        parDiv.append(childDiv2);

        if (r === 1 && c === dataArray[r].length - 1) {
          $('<svg id="topsvg" width="100%" height="20px"></svg>').appendTo("#mroichart");
        }
        if (r === dataArray.length - 1 && c === dataArray[r].length - 1) {
          $('<svg id="bottomsvg" width="100%" height="20px"> </svg>').appendTo(parDiv);
        }
      }

      $("#mroichart").append(parDiv);
      $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
    }

    $("div.elltooltip")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.rectslice")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.cillindreslice")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.box-funnel-chart")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    countShadows();
  };

  const countTotal = () => {
    for (let i = 0; i < dataArray[1].length; i++) {
      totalCount += dataArray[1][i][0];
    }
    const childrenValues = [];
    for (let k = 0; k < dataArray[dataArray.length - 1].length; k++) {
      childrenValues[k] = dataArray[dataArray.length - 1][k][0];
    }

    maxCylinder = Math.max.apply(Math, childrenValues);
  };

  const countShadows = () => {
    let css = "<style>";
    for (let i = 1; i < 3; i++) {
      let bWidth = ($(".s" + [i]).width() - $(".s" + [i + 1]).width()) / 2;

      css +=
        ".s" +
        i +
        ":after{border-left-width: " +
        bWidth +
        "px; border-right-width:" +
        bWidth +
        "px; }";
    }

    css += "</style>";
    $("head").append(css);

    createTopConnections();
  };

  const createTopConnections = () => {
    for (let n = 0; n < dataArray[0].length; n++) {
      const currEll = $(".elltooltip")[n];
      const currRect = $(".rectslice")[n];

      const offset = (chartWidth - $($(".chartsection")[0]).width()) / 2;
      const color = $(currEll).css("background-color");

      const x1 = parseInt($(currEll).width() / 2 + $(currEll).position().left + offset);
      const x2 = parseInt($(currRect).width() / 2 + $(currRect).position().left);

      $("#topsvg").css("width", chartWidth);
      $("#topsvg").append(
        '<svg><path d="M' +
          x1 +
          ",0 C" +
          x1 +
          ",20 " +
          x2 +
          ",0 " +
          x2 +
          ',20" style="stroke:' +
          color +
          '; stroke-width:1; fill:none;" shape-rendering="optimizeQuality"/></svg>'
      );
    }
    createBottomConnections();
  };

  const createBottomConnections = () => {
    for (let n = 0; n < dataArray[0].length; n++) {
      const currEll = $(".cillindreslice")[n];
      const currRect = $($(".chartsection")[dataArray.length - 2]).children(".rectslice")[n];

      const offsetRect =
        ($("#mroichart").width() - $($(".chartsection")[dataArray.length - 2]).width()) / 2;
      const offsetEll =
        ($("#mroichart").width() - $($(".chartsection")[dataArray.length - 1]).width()) / 2;

      const offset = offsetRect - offsetEll;

      const color = $(currEll).css("background-color");

      const x1 = parseInt($(currRect).width() / 2 + $(currRect).position().left + offset);
      const x2 = parseInt($(currEll).width() / 2 + $(currEll).position().left);

      const y2 = $(currEll).position().top;

      $("#bottomsvg").append(
        '<svg><path d="M' +
          x1 +
          ",0 C" +
          x1 +
          "," +
          y2 +
          " " +
          x2 +
          ",0 " +
          x2 +
          "," +
          y2 +
          '" style="stroke:' +
          color +
          '; stroke-width:1.5; fill:none;" shape-rendering="optimizeQuality"/></svg>'
      );
    }
    placeMetrics();
  };

  const placeMetrics = () => {
    for (let i = 0; i < dataArray.length - 2; i++) {
      const chartLabel = $(".metrics")[i];
      const chartLabelWidth = chartLabel.offsetWidth;
      const chartSection = $(".s" + (i + 1)).width();
      // left and right offsets are the same as content centered
      const chartSectionOffset = $(".s" + (i + 1)).position().left;

      const maxWidthForText = 1270 - chartSection - chartSectionOffset - 15;

      if (chartLabelWidth > maxWidthForText) {
        chartLabel.parentElement.style.width = maxWidthForText + "px";
        chartLabel.parentElement.style.height = "auto";
        $(".iitem2").css("marginTop", "30px");
      }
    }
  };

  return (
    <div id="funnel_retention_chart">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-9 col-sm-9 col-md-9 col-lg-10">
            <div className="fullcontainer">
              <div className="row text-center">
                <div id="mroichart" />
              </div>

              <div className="infoside">
                <div className="offers-sold">
                  <span
                    className="metrics"
                    title="Offers Sold to New Or Existing Clients"
                    data-toggle="tooltip"
                    data-placement="top"
                  >
                    {label ? label : "Offers"} Sold: {totalOffers(dataArray)}
                  </span>
                </div>

                <div className="row">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div className="iitem">
                      <span className="metrics">
                        Converted to Service: {convertToAny(dataArray, 2)}
                      </span>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div className="iitem iitem2">
                      <span className="metrics">
                        Converted to Membership: {convertToAny(dataArray, 3)}
                      </span>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6" />
                  </div>
                </div>
              </div>
              <div className="flex-container">
                <div className="charttotal">
                  {dataArray[4].map((item, key) => (
                    <div key={key} className={`totalitem ${colors[key]}`}>
                      <h5>{item[1]}</h5>
                      <br />
                      <h6 className="average">Service Sales Total: {item[2]}</h6>
                      <h6 className="average">Product Sales Total: {item[3]}</h6>
                      <br />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomoFunnel;

DomoFunnel.propTypes = {
  dataArray: PropTypes.array,
  chartWidth: PropTypes.number,
  label: PropTypes.string
};
